import i18n from 'modules/core/lib/i18n'

import type AllowanceIncidenceForm from 'modules/timeoff/lib/AllowanceIncidence'

export const validateLessThanThreeDecimals = (
  form: AllowanceIncidenceForm,
  setFormError: (value: boolean) => void
) => {
  const value = form.get('days_in_cents').value
  const valueArr = value.split(/[.,]/)

  if (valueArr.length < 2) {
    return null
  }

  const decimals = valueArr.pop()

  if (decimals.length > 2) {
    setFormError(true)

    return i18n.t('time_off.incidences.errors.more_than_two_decimals')
  }

  setFormError(false)
}
